var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2948_12918)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80 0C35.8883 0 0 35.8883 0 80C0 124.112 35.8883 160 80 160C124.112 160 160 124.112 160 80C160 35.8883 124.112 0 80 0ZM80 147.71C42.6645 147.71 12.2902 117.335 12.2902 80C12.2902 42.6645 42.6645 12.2902 80 12.2902C117.335 12.2902 147.71 42.6645 147.71 80C147.71 117.335 117.335 147.71 80 147.71Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0004 33.9395C74.6539 33.9395 70.3047 38.2911 70.3047 43.6401C70.3047 48.9891 74.6539 53.3333 80.0004 53.3333C85.3469 53.3333 89.6961 48.9841 89.6961 43.6401C89.6961 38.2961 85.3469 33.9395 80.0004 33.9395Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0002 67.8789C75.9835 67.8789 72.7266 71.1358 72.7266 75.1525V118.789C72.7266 122.806 75.9835 126.063 80.0002 126.063C84.0169 126.063 87.2738 122.806 87.2738 118.789V75.1525C87.2738 71.1358 84.0169 67.8789 80.0002 67.8789Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2948_12918"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.f14d03b8.svg";
export { ForwardRef as ReactComponent };